import React from 'react';

export default class RadioButton extends React.Component {
  onChangeFunction = (event, data, scope) => {
    const selectedData = Object.assign({}, data);
    selectedData.checked = event.target.checked;
    if (scope.props.onChangeFunction) {
      scope.props.onChangeFunction(selectedData, event);
    }
  }

  componentWillReceiveProps(props) {
    if (this.props.changeOnPropsChange) {
      this.setChecked(props.checked);
    }
  }

  onClickFunction = (event, data, scope) => {
    const selectedData = Object.assign({}, data);
    selectedData.checked = event.target.checked;
    if (scope.props.onClickFunction) {
      scope.props.onClickFunction(selectedData, event);
    }
  }

  getValue = () => {
    if (this.selectedVal) {
      return this.selectedVal.value;
    }
    return '';
  }
  isChecked() {
    return this.selectedVal.checked;
  }
  setChecked(chk) {
    this.selectedVal.checked = chk;
  }
  render() {
    const props = this.props;
    const _radioHtml =
      (<React.Fragment><div className={props.radioCssClass}>
        <input
          id={props.id}
          type="radio"
          name={props.name}
          defaultChecked={props.checked}
          ref={selectedVal => this.selectedVal = selectedVal}
          value={props.value}
          onChange={event => this.onChangeFunction(event, this.props, this)}
          onClick={event => this.onClickFunction(event, this.props, this)}
          disabled={props.disabled}
          checked={this.props.checked}
        />
        <label htmlFor={props.id} className='custom-radio-label'>{props.displayName}{this.props.subDetailsHTML ? this.props.subDetailsHTML : null}</label>
        {this.props.innerContent ? this.props.innerContent : null}
      </div>
        {props.children ? props.children : null}
      </React.Fragment>
      );
    return (
      _radioHtml
    );
  }
}
